import React from "react";
import "../../../css/Views/TfgPreviewChanges.css";

const MULTILINE_PROPERTIES = [
  "payments",
  "refunds",
];

const renderChangeValue = (
  value,
  property
) => {
  if (!value) {
    return "Brak";
  }

  const isMultiline =
    MULTILINE_PROPERTIES.includes(
      property?.toLowerCase()
    );

  if (!isMultiline) {
    return value;
  }

  const lines = Array.isArray(value)
    ? value
    : String(value)
        .split("\n")
        .filter(Boolean);

  return (
    <div className="tfg-change-lines">
      {lines.map((line, index) => (
        <div
          key={`${line}-${index}`}
          className="tfg-change-line"
        >
          <span>•</span>
          <span>{line}</span>
        </div>
      ))}
    </div>
  );
};

const TfgPreviewChanges = ({
  changes,
}) => (
  <section className="tfg-preview-section">
    <h3 className="tfg-preview-section-title">
      Wykryte zmiany
    </h3>

    {!changes?.length ? (
      <div className="tfg-preview-muted">
        Brak zmian.
      </div>
    ) : (
      <div className="tfg-changes-list">
        {changes.map((change) => (
          <div
            key={change.property}
            className="tfg-change-item"
          >
            <div className="tfg-change-name">
              {change.displayName}
            </div>

            <div className="tfg-change-values">
              <div className="tfg-change-value">
                <span>Poprzednio</span>

                <div>
                  {renderChangeValue(
                    change.oldValue,
                    change.property
                  )}
                </div>
              </div>

              <div className="tfg-change-value">
                <span>Obecnie</span>

                <div>
                  {renderChangeValue(
                    change.newValue,
                    change.property
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )}
  </section>
);

export default TfgPreviewChanges;